import { ParentCategory } from '../../category-selector/CategorySelector'

export const getDateSelectorItems = () => {
  return [
    {
      id: 1,
      type: 'relative',
      name: 'Less than',
      value: 'lt',
      unit: 'hour'
    },
    {
      id: 3,
      type: 'relative',
      name: 'More than',
      value: 'gt',
      unit: 'hour'
    },
    {
      id: 4,
      type: 'absolute',
      name: 'Before',
      value: 'before'
    },
    {
      id: 5,
      type: 'absolute',
      name: 'On',
      value: 'on'
    },
    {
      id: 6,
      type: 'absolute',
      name: 'After',
      value: 'after'
    }
  ]
}

export const getRangeSelectorItems = () => {
  return [
    {
      id: 1,
      name: 'More than',
      value: 'gt'
    },
    {
      id: 2,
      name: 'Equal to',
      value: 'eq'
    },
    {
      id: 3,
      name: 'Less than',
      value: 'lt'
    }
  ]
}

export const getBooleanSelectorItems = () => {
  return [
    {
      id: 1,
      name: 'Yes',
      value: true
    },
    {
      id: 2,
      name: 'No',
      value: false
    }
  ]
}

export const normalizeCategories = (categories: ParentCategory[]) => {
  return categories
    .filter(parent => parent.categories)
    .map(parent => {
      return {
        parentId: parent.groupId,
        parentName: parent.groupName,
        items: parent.categories?.map((child: { categoryName: any; categoryId: any }, idx: any) => {
          return {
            id: idx,
            name: child.categoryName,
            value: child.categoryId
          }
        })
      }
    })
}
